export function isRateUnavailable(rate) {
    const blockedBySport = rate.get('isBlockedBySport');
    if (blockedBySport !== undefined && blockedBySport) {
        return true;
    }

    const blockedByLeague = rate.get('isBlockedByLeague');
    if (blockedByLeague !== undefined && blockedByLeague) {
        return true;
    }

    const blockedByMatch = rate.get('isBlockedByMatch');
    if (blockedByMatch !== undefined && blockedByMatch) {
        return true;
    }

    const blockedByGroup = rate.get('isBlockedByGroup');
    if (blockedByGroup !== undefined && blockedByGroup) {
        return true;
    }

    const blockedByOutcome = rate.get('isBlockedByOutcome');

    return !!(blockedByOutcome !== undefined && blockedByOutcome);
}

export function rateFactorChangeConfirmNeeded(rate) {
    const actualValue = rate.get('actualValue');
    const originalValue = rate.get('value');
    const blockedByRate = rate.get('isBlocked');

    if (actualValue === undefined || blockedByRate === undefined || blockedByRate === false) {
        return false;
    }

    return actualValue !== originalValue;
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/rateUtils.js